import React from 'react';

import { UncontrolledPopover, PopoverBody, Alert } from 'reactstrap';

import './qcNote.css';

export function hasQcStatusNote({ qc_passed, qc_feedback, edited_after_qc }) {
  if (edited_after_qc) {
    return false;
  }
  const hasQcFeedback =
    qc_feedback?.results && Object.keys(qc_feedback.results).length !== 0;
  return qc_passed === false || !!hasQcFeedback;
}

const QCNote = ({
  id,
  order,
  rowIndex,
  status,
  name,
  qc_passed,
  qc_feedback,
  edited_after_qc,
  noteType,
}) => {
  const idPart =
    id != null && id !== ""
      ? String(id)
      : order != null && order !== ""
        ? `ord-${String(order)}`
        : `idx-${rowIndex != null ? String(rowIndex) : "0"}`;
  const rowId = `${noteType}-row-qcn-${idPart}`;
  const showStatusNote = hasQcStatusNote({ qc_passed, qc_feedback, edited_after_qc });

  let statusNoteText = `${noteType} ${name || ""} has QC Issues, please edit the ${noteType} for detailed QC Feedback, make required changes and resubmit!`;

  return (
    <div>
      <i className={"fas fa-bell fa-2x note-icon" + (showStatusNote ? " note-avl-icon" : "")} id={rowId} aria-hidden="true" disabled={!showStatusNote}></i>
      <UncontrolledPopover trigger="legacy" id="qc-popover" placement="bottom" target={rowId} disabled={!showStatusNote}>
        <PopoverBody style={{padding: "0px"}}>
          { showStatusNote &&
            <Alert color="danger" style={{fontSize: "14px", fontWeight: "bolder", margin: "0px"}} fade={true} isOpen={showStatusNote}>
              <b>{statusNoteText}</b>
            </Alert>
          }
        </PopoverBody>
      </UncontrolledPopover>
    </div>
  );
};

export default QCNote;
